import React, { useEffect, useState, useCallback } from "react";
import { api } from "../../api/client";
import ConfirmModal from "../../components/ConfirmModal";
import MapPicker from "./MapPicker";
import { Field, CoordsFields } from "./CartoDAEAdmin";

const TYPES = [
  { v: "eglise", l: "Église" }, { v: "monument", l: "Monument" },
  { v: "lavoir", l: "Lavoir" }, { v: "ruine", l: "Ruine / vestige" },
  { v: "moulin", l: "Moulin" }, { v: "autre", l: "Autre" },
];
const labelType = (t) => (TYPES.find((x) => x.v === t) || { l: t }).l;

export default function CartoPatrimoineAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [toDelete, setToDelete] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { setItems((await api.get("/admin/cartographie/patrimoine")).items || []); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const confirmDelete = async () => {
    try { await api.del(`/admin/cartographie/patrimoine/${toDelete.id}`);
          setToDelete(null); load();
    } catch (e) { alert("Erreur : " + e.message); }
  };

  const blank = { nom: "", type: "autre", description: "",
                  latitude: 48.1102, longitude: 0.0815 };

  return (
    <div>
      <button onClick={() => setEditing(blank)}>+ Ajouter un élément</button>
      {loading && <p className="muted mt-2">Chargement…</p>}
      {!loading && items.length === 0 &&
        <p className="muted mt-2">Aucun élément de patrimoine.</p>}
      {items.length > 0 && (
        <table className="admin-table mt-2"><thead><tr>
          <th>Nom</th><th>Type</th><th>Coordonnées</th><th>Actions</th>
        </tr></thead><tbody>
          {items.map((p) => (
            <tr key={p.id}>
              <td>{p.nom}</td>
              <td className="muted">{labelType(p.type)}</td>
              <td className="muted" style={{ fontFamily: "monospace", fontSize: "0.85em" }}>
                {p.latitude.toFixed(5)}, {p.longitude.toFixed(5)}
              </td>
              <td>
                <button className="small" onClick={() => setEditing(p)}>Modifier</button>
                <button className="small danger" style={{ marginLeft: 6 }}
                        onClick={() => setToDelete(p)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody></table>
      )}
      {editing && (
        <Editor item={editing}
                onClose={() => setEditing(null)}
                onSaved={() => { setEditing(null); load(); }} />
      )}
      {toDelete && (
        <ConfirmModal title="Supprimer cet élément ?"
                      message={`« ${toDelete.nom} » sera définitivement supprimé.`}
                      confirmLabel="Supprimer" variant="danger"
                      onConfirm={confirmDelete} onCancel={() => setToDelete(null)} />
      )}
    </div>
  );
}

function Editor({ item, onClose, onSaved }) {
  const [form, setForm] = useState(item);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (!form.nom.trim()) { setError("Le nom est obligatoire."); return; }
    setBusy(true);
    try {
      const payload = { ...form, nom: form.nom.trim() };
      if (item.id) await api.put(`/admin/cartographie/patrimoine/${item.id}`, payload);
      else await api.post("/admin/cartographie/patrimoine", payload);
      onSaved();
    } catch (e) { setError(e.message || "Erreur"); }
    finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 920, width: "95vw" }}>
        <div className="modal-header">
          <h3>{item.id ? "Modifier" : "Ajouter"} un élément de patrimoine</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p className="muted" style={{ fontSize: "0.85em" }}>
            Cliquez sur la carte pour positionner.
          </p>
          <MapPicker latitude={form.latitude} longitude={form.longitude}
                     onChange={(ll) => setForm((f) => ({ ...f, ...ll }))} />
          <CoordsFields form={form} setForm={setForm} />
          <Field label="Nom" value={form.nom}
                 onChange={(v) => setForm({ ...form, nom: v })} />
          <div className="field"><label>Type</label>
            <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
              {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
            </select></div>
          <div className="field"><label>Description</label>
            <textarea rows={4} value={form.description || ""}
                      onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          {error && <div className="error mt-2">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="secondary" onClick={onClose}>Annuler</button>
          <button onClick={submit} disabled={busy}>
            {busy ? "Enregistrement…" : "Enregistrer"}
          </button>
        </div>
      </div>
    </div>
  );
}
